/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiARecordIcon16Solid = forwardRef('MediaUiARecordIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z" })));
});
